import React, { useMemo, useState } from 'react'
import { _getSimilarStringUpto, formatMoney } from '../lib/util';
import { Checkbox, Collapse, Descriptions, Table, Popconfirm } from 'antd';
import { COLORS, OUR_COLOR, THEIR_COLOR } from '../pages/theme';
import { ExpandMoreOutlined, MoreHorizOutlined, KeyboardArrowRightOutlined } from '@material-ui/icons';
import moment from 'moment';
import Paragraph from 'antd/lib/typography/Paragraph';
import Highlighter from 'react-highlight-words';
import DayDifferennceTag from './day_difference_tag';


const LEFT_RIGHT_PADDING = 16;
const TOP_BOTTOM_PADDING = 12;


function ShowCompare({
    ours_value, theirs_value, ours_key, theirs_key
}) {

    let matched_obj = React.useMemo(() => _getSimilarStringUpto(ours_value, theirs_value), [ours_value, theirs_value]);

    return <div style={{
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'nowrap',
    }}>
        <div style={{
            display: 'flex',
            flex: 1,
            flexDirection: 'row',
            justifyContent: 'space-between',
            flexWrap: 'nowrap',
            paddingRight: LEFT_RIGHT_PADDING,
            borderRight: `1px solid ${COLORS.border_basic}`,
            paddingTop: 6,
            paddingBottom: 6
        }}>
            <span className='header-label' style={{ color: OUR_COLOR, textTransform: 'uppercase' }}>{ours_key}</span>
            {/* <span className='content-label'>{ours_value}</span> */}
            <Highlighter
                highlightClassName='highlighter'
                className=' content-label'
                searchWords={[`${matched_obj.value}`]}
                autoEscape={true}
                textToHighlight={`${ours_value}`}
            />

        </div>
        <div style={{
            display: 'flex',
            flex: 1,
            flexDirection: 'row-reverse',
            justifyContent: 'space-between',
            flexWrap: 'nowrap',
            paddingLeft: LEFT_RIGHT_PADDING,
            paddingTop: 6,
            paddingBottom: 6
        }}>
            <span className='header-label' style={{ color: THEIR_COLOR, textTransform: 'uppercase' }}>{theirs_key}</span>
            <Highlighter
                highlightClassName='highlighter'
                className=' content-label'
                searchWords={[`${matched_obj.value}`]}
                autoEscape={true}
                textToHighlight={`${theirs_value}`}
            />
        </div>

    </div>
}

export default function PendingReconciledItem({
    data = {},
    selectedIDS = [],
    id,
    rule = {},
    onSelect,
    onViewDetailClicked,
    onApprove,
    onReject,
    index
}) {
    const [expanded, toggleExpand] = useState(false);

    let ref = data.__references__ || {};
    let ours = ref.our_txn_relation || {};
    let theirs = ref.their_txn_relation || {};
    let our_time = moment(ours.txn_date, "YYYY-MM-DD");
    let their_time = moment(theirs.txn_date, "YYYY-MM-DD");
    let time_diff = our_time.diff(their_time, 'days');
    // console.log("time dif", time_diff)

    // const memoizedValue = useMemo(() => _getSimilarStringUpto(`${ours.description}blah`, `${theirs.description}bhh`), [`${ours.description}blah`, `${theirs.description}bhh`]);
    // console.log("matching begin",memoizedValue)

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'row',
            flex: 1,
            width: '100%',
            alignItems: 'center',
            flexWrap: 'nowrap'
        }}>
            <div style={{
                width: 40,
                // backgroundColor: 'red',
                margin: 8,
                marginRight: 0,
                marginLeft: 0,
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center'
            }}>
                <Checkbox
                    checked={selectedIDS.includes(id)}
                    onChange={(e) => {
                        typeof onSelect === 'function' && onSelect(id, data);
                    }}
                />
            </div>
            <div className='filter-card' style={{
                flex: 1,
                maxWidth: 'calc(100% - 40px)',
                padding: 0,
                margin: 0,
                marginLeft: 8,
                // paddingBottom:8
            }}>
                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    flexWrap: 'nowrap',
                }}>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        flex: 1,
                        borderRight: `1px solid ${COLORS.border_basic}`,
                        paddingTop: TOP_BOTTOM_PADDING, paddingBottom: TOP_BOTTOM_PADDING,
                        paddingLeft: LEFT_RIGHT_PADDING, paddingRight: LEFT_RIGHT_PADDING
                    }}>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            flexWrap: 'nowrap',

                        }}>
                            <div style={{ paddingRight: 12 }}>
                                <div
                                    title={ours.type == 'C' ? "Credit" : (ours.type == 'D' ? "Debit" : "N/A")}
                                    className={ours.type === 'D' ? 'debit-circle' : ours.type == 'C' ? 'credit-circle' : 'na-circle'}
                                >
                                    {ours.type}
                                </div>
                            </div>
                            <div style={{ flex: 1 }}>
                                <div className='heading-2'>{ours.txn_date}</div>
                            </div>
                            <div style={{ flex: 1 }}>
                                <div className='heading-2'>{ours.transaction_id}</div>
                            </div>
                            <div style={{
                                flex: 1,
                                textAlign: 'right'
                            }}>
                                <div className='heading-2' style={{
                                    color: COLORS.primary
                                }}>{formatMoney(ours.amount)}</div>
                            </div>
                        </div>

                        <div style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            flexWrap: 'nowrap',
                            marginTop: 8
                        }}>
                            <span className='sub-heading-3 word-break' style={{
                                color: COLORS.secondary
                            }}>
                                {ours.description}
                            </span>
                            <span className='hand-cursor' style={{ marginLeft: 8 }}>
                                <MoreHorizOutlined
                                    className='hand-cursor main-icon' style={{ marginLeft: 8 }}
                                    titleAccess="View Ours Detail"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        typeof onViewDetailClicked === 'function' && onViewDetailClicked(ours.id)
                                    }}
                                />
                            </span>
                        </div>

                    </div>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        flex: 1,
                        // borderRight:`1px solid ${COLORS.border_basic}`,
                        paddingTop: TOP_BOTTOM_PADDING, paddingBottom: TOP_BOTTOM_PADDING,
                        paddingLeft: LEFT_RIGHT_PADDING, paddingRight: LEFT_RIGHT_PADDING
                    }}>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            flexWrap: 'nowrap',

                        }}>
                            <div style={{ paddingRight: 12 }}>
                                <div
                                    title={theirs.type == 'C' ? "Credit" : (theirs.type == 'D' ? "Debit" : "N/A")}
                                    className={theirs.type === 'D' ? 'debit-circle' : theirs.type == 'C' ? 'credit-circle' : 'na-circle'}

                                >
                                    {theirs.type}
                                </div>
                            </div>
                            <div style={{ flex: 1 }}>
                                <div className='heading-2'>{theirs.txn_date}</div>
                            </div>
                            <div style={{ flex: 1 }}>
                                <div className='heading-2'>{theirs.transaction_id}</div>
                            </div>
                            <div style={{
                                flex: 1,
                                textAlign: 'right'
                            }}>
                                <div className='heading-2' style={{
                                    color: COLORS.primary
                                }}>{formatMoney(theirs.amount)}</div>
                            </div>
                        </div>

                        <div style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            flexWrap: 'nowrap',
                            marginTop: 8
                        }}>
                            <span className='sub-heading-3 word-break' style={{
                                color: COLORS.secondary
                            }}>
                                {theirs.description}
                            </span>
                            <span className='hand-cursor' style={{ marginLeft: 8 }}>
                                <MoreHorizOutlined
                                    className='hand-cursor main-icon' style={{ marginLeft: 8 }}
                                    titleAccess="View Theirs Detail"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        typeof onViewDetailClicked === 'function' && onViewDetailClicked(theirs.id)
                                    }}
                                />
                            </span>
                        </div>


                    </div>

                </div>


                {rule.id && Array.isArray(rule.field_comparisons) && rule.field_comparisons.length > 0 &&
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        flexWrap: 'nowrap',
                        borderTop: `1px solid ${COLORS.border_basic}`,
                        // paddingTop: TOP_BOTTOM_PADDING, paddingBottom: TOP_BOTTOM_PADDING,
                        paddingLeft: LEFT_RIGHT_PADDING, paddingRight: LEFT_RIGHT_PADDING
                    }}>
                        {rule.field_comparisons.map((comparison_item) => {

                            let our_column_key = comparison_item.our_column || "";
                            let their_column_key = comparison_item.their_column || "";

                            let our_parsed = ours.parsed_data || {};
                            let our_enriched = ours.enriched_data || {};
                            let our_extracted = ours.extracted_value || {};
                            let ours_value = (our_parsed[our_column_key] || our_enriched[our_column_key] || ours[our_column_key] || our_extracted[our_column_key]) || "";
                            if (typeof ours_value === 'object') {
                                ours_value = JSON.stringify(ours_value);
                            }
                            let their_parsed = theirs.parsed_data || {};
                            let their_enriched = theirs.enriched_data || {};
                            let their_extracted = theirs.extracted_value || {};
                            let theirs_value = (their_parsed[their_column_key] || their_enriched[their_column_key] || theirs[their_column_key] || their_extracted[their_column_key]) || "";
                            if (typeof theirs_value === 'object') {
                                theirs_value = JSON.stringify(theirs_value);
                            }

                            return <ShowCompare

                                ours_key={our_column_key}
                                theirs_key={their_column_key}
                                ours_value={ours_value}
                                theirs_value={theirs_value}
                            />


                            const matched_obj = _getSimilarStringUpto(ours_value, theirs_value);
                            // console.log("matched", matched_obj)

                            return <div style={{
                                display: 'flex',
                                flexDirection: 'row',
                                flexWrap: 'nowrap',
                            }}>
                                <div style={{
                                    display: 'flex',
                                    flex: 1,
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                    flexWrap: 'nowrap',
                                    paddingRight: LEFT_RIGHT_PADDING,
                                    borderRight: `1px solid ${COLORS.border_basic}`,
                                }}>
                                    <span className='header-label' style={{ color: OUR_COLOR, textTransform: 'uppercase' }}>{our_column_key}</span>
                                    {/* <span className='content-label'>{ours_value}</span> */}
                                    <Highlighter
                                        highlightClassName='highlighter'
                                        className=' content-label'
                                        searchWords={[`${matched_obj.value}`]}
                                        autoEscape={true}
                                        textToHighlight={`${ours_value}`}
                                    />

                                </div>
                                <div style={{
                                    display: 'flex',
                                    flex: 1,
                                    flexDirection: 'row-reverse',
                                    justifyContent: 'space-between',
                                    flexWrap: 'nowrap',
                                    paddingLeft: LEFT_RIGHT_PADDING,
                                }}>
                                    <span className='header-label' style={{ color: THEIR_COLOR, textTransform: 'uppercase' }}>{their_column_key}</span>
                                    <Highlighter
                                        highlightClassName='highlighter'
                                        className=' content-label'
                                        searchWords={[`${matched_obj.value}`]}
                                        autoEscape={true}
                                        textToHighlight={`${theirs_value}`}
                                    />
                                </div>

                            </div>
                        })}

                        {false && <div style={{
                            display: 'none',
                            flexDirection: 'column',
                            flex: 1,
                            borderRight: `1px solid ${COLORS.border_basic}`,
                            paddingTop: TOP_BOTTOM_PADDING, paddingBottom: TOP_BOTTOM_PADDING,
                            paddingLeft: LEFT_RIGHT_PADDING, paddingRight: LEFT_RIGHT_PADDING
                        }}>
                            {rule.field_comparisons.map((comparison_item) => {
                                let our_column_key = comparison_item.our_column || "";
                                // let their_column_key=comparison_item.their_column||"";

                                let our_parsed = ours.parsed_data || {};
                                let our_enriched = ours.enriched_data || {};
                                let our_extracted = ours.extracted_value || {};
                                let ours_value = (our_parsed[our_column_key] || our_enriched[our_column_key] || ours[our_column_key] || our_extracted[our_column_key]) || "";
                                if (typeof ours_value === 'object') {
                                    ours_value = JSON.stringify(ours_value);
                                }
                                // let their_parsed = theirs.parsed_data || {};
                                // let their_enriched = theirs.enriched_data || {};
                                // let their_extracted = theirs.extracted_value || {};
                                // let theirs_value=(their_parsed[rule.their_column] || their_enriched[rule.their_column] || theirs[rule.their_column] || their_extracted[rule.their_column])||"";
                                // if(typeof theirs_value==='object'){
                                //     theirs_value=JSON.stringify(theirs_value);
                                // }
                                return <div style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                    flexWrap: 'nowrap'
                                }}>
                                    <span className='header-label' style={{ color: OUR_COLOR, textTransform: 'uppercase' }}>{our_column_key}</span>
                                    <span className='content-label'>{ours_value}</span>

                                </div>
                            })}
                        </div>
                        }
                        {false && <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            flex: 1,
                            // borderRight: `1px solid ${COLORS.border_basic}`,
                            // paddingTop: TOP_BOTTOM_PADDING, paddingBottom: TOP_BOTTOM_PADDING,
                            paddingLeft: LEFT_RIGHT_PADDING, paddingRight: LEFT_RIGHT_PADDING
                        }}>
                            {rule.field_comparisons.map((comparison_item) => {
                                let our_column_key = comparison_item.our_column || "";
                                let their_column_key = comparison_item.their_column || "";

                                let our_parsed = ours.parsed_data || {};
                                let our_enriched = ours.enriched_data || {};
                                let our_extracted = ours.extracted_value || {};
                                let ours_value = (our_parsed[our_column_key] || our_enriched[our_column_key] || ours[our_column_key] || our_extracted[our_column_key]) || "";
                                if (typeof ours_value === 'object') {
                                    ours_value = JSON.stringify(ours_value);
                                }
                                let their_parsed = theirs.parsed_data || {};
                                let their_enriched = theirs.enriched_data || {};
                                let their_extracted = theirs.extracted_value || {};
                                let theirs_value = (their_parsed[their_column_key] || their_enriched[their_column_key] || theirs[their_column_key] || their_extracted[their_column_key]) || "";
                                if (typeof theirs_value === 'object') {
                                    theirs_value = JSON.stringify(theirs_value);
                                }


                                const matched_obj = _getSimilarStringUpto(ours_value, theirs_value);
                                console.log("matched", matched_obj)
                                // const memoizedValue = useMemo(() => _getSimilarStringUpto(`${ours.description}blah`, `${theirs.description}bhh`), [`${ours.description}blah`, `${theirs.description}bhh`]);
                                // console.log("matching begin",memoizedValue)

                                return <div style={{
                                    display: 'flex',
                                    flexDirection: 'row-reverse',
                                    justifyContent: 'space-between',
                                    flexWrap: 'nowrap'
                                }}>
                                    <span className='header-label' style={{ color: THEIR_COLOR, textTransform: 'uppercase' }}>{their_column_key}</span>
                                    <Highlighter
                                        highlightClassName='highlighter'
                                        className=' content-label'
                                        searchWords={[`${matched_obj.value}`]}
                                        autoEscape={true}
                                        textToHighlight={`${theirs_value}`}
                                    />
                                    {/* <pre>
                                        {matched_obj.index>0?
                                        theirs_value.insert(matched_obj.index+1,'</mark>').insert(0,'<mark>')
                                        :theirs_value    
                                    }
                                    </pre> */}
                                </div>
                            })}
                        </div>
                        }
                    </div>
                }
                <div style={{
                    borderTop: `1px solid ${COLORS.border_basic}`,
                    paddingLeft: LEFT_RIGHT_PADDING, paddingRight: LEFT_RIGHT_PADDING,
                    paddingTop: 8,
                    paddingBottom: 8,
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }}>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center'
                    }}>
                        {data.action && typeof data.action === 'string' &&
                            <div
                                title={data.action}
                                style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    padding: 4,
                                    marginRight: 26,
                                    backgroundColor: COLORS.success_primary,
                                    width: 27,
                                    height: 27,
                                    borderRadius: 2,
                                    color: COLORS.white
                                }}>
                                <span className='sub-heading-3 ' style={{
                                    color: COLORS.white
                                }}>{data.action.charAt(0)}</span>
                            </div>}
                        <span className='sub-heading-3 ' style={{
                            color: COLORS.secondary
                        }}>{rule.name}</span>
                    </div>
                    <div style={{
                        display: 'flex'
                    }}>
                        <span className='sub-heading-3' style={{
                            color: COLORS.secondary
                        }}>DAY OFFSET : &nbsp;&nbsp;</span>
                        <DayDifferennceTag date={theirs.txn_date} dateFrom={ours.txn_date} />
                    </div>
                </div>


                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    borderTop: `1px solid ${COLORS.border_basic}`,
                    paddingTop: TOP_BOTTOM_PADDING, paddingBottom: TOP_BOTTOM_PADDING,
                    paddingLeft: LEFT_RIGHT_PADDING, paddingRight: LEFT_RIGHT_PADDING
                }}>
                    <div
                        title={expanded ? "COLLAPSE" : "EXPAND"}
                        className='hand-cursor sub-heading-3'

                        onClick={() => {
                            toggleExpand(!expanded)
                        }}
                        style={{
                            display: 'flex',
                            color: COLORS.secondary
                        }}>{expanded ? "LESS" : "MORE"} <ExpandMoreOutlined style={{
                            transform: `rotate(${expanded ? 180 : 0}deg)`,
                            transition: 'transform 200ms '
                        }} /></div>
                    <span className='sub-heading-3' style={{
                        color: COLORS.secondary
                    }}>PROCESSED BY: {data.manual ? "USER NAME" : "SYSTEM"}</span>

                </div>
                {expanded ? <React.Fragment><div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    borderTop: `1px solid ${COLORS.border_basic}`,
                    // paddingTop: TOP_BOTTOM_PADDING, paddingBottom: TOP_BOTTOM_PADDING,
                    // paddingLeft: LEFT_RIGHT_PADDING, paddingRight: LEFT_RIGHT_PADDING
                }}>
                    <Collapse style={{ backgroundColor: 'white' }} bordered={false} expandIconPosition='right'
                        expandIcon={(panelProps) => {
                            console.log("props", panelProps.isActive);
                            return <KeyboardArrowRightOutlined
                                style={{
                                    color: COLORS.secondary,
                                    transform: `rotate(${panelProps.isActive ? 90 : 0}deg)`,
                                    transition: `all 0.2s ease-in-out`,
                                    top: 12,
                                    fontSize: 20
                                }}
                            />
                        }}
                    >
                        <Collapse.Panel header={<span className='sub-heading-3' style={{ color: COLORS.secondary }}>OUR PARSED DATA</span>} key="1">
                            {ours.parsed_data && Object.keys(ours.parsed_data).length > 0 &&
                                <Descriptions className='small-description' bordered size='small' layout='horizontal'>
                                    {Object.keys(ours.parsed_data).map((key) => {
                                        if (!key.startsWith('__')) {
                                            return <Descriptions.Item key={key} label={key} className='log-text' >
                                                <Paragraph >
                                                    {typeof ours.parsed_data[key] === 'string' || typeof ours.parsed_data[key] === 'number' ? ours.parsed_data[key] : JSON.stringify(ours.parsed_data[key])}
                                                </Paragraph>
                                            </Descriptions.Item>

                                        }
                                    })}
                                </Descriptions>
                            }
                        </Collapse.Panel>
                        <Collapse.Panel header={<span className='sub-heading-3' style={{ color: COLORS.secondary }}>THEIR PARSED DATA</span>} key="2">
                            {theirs.parsed_data && Object.keys(theirs.parsed_data).length > 0 &&
                                <Descriptions className='small-description' bordered size='small' layout='horizontal'>
                                    {Object.keys(theirs.parsed_data).map((key) => {
                                        if (!key.startsWith('__')) {
                                            return <Descriptions.Item key={key} label={key} className='log-text' >
                                                <Paragraph >
                                                    {typeof theirs.parsed_data[key] === 'string' ? theirs.parsed_data[key] : JSON.stringify(theirs.parsed_data[key])}
                                                </Paragraph>
                                            </Descriptions.Item>

                                        }
                                    })}
                                </Descriptions>
                            }
                        </Collapse.Panel>

                        <Collapse.Panel header={<span className='sub-heading-3' style={{ color: COLORS.secondary }}>ACTION LOGS</span>} key="3">
                            <Table
                                // scroll={{ x: true }}
                                // style={{
                                //     width:'100%',
                                //     maxWidth:'100%'
                                // }}
                                dataSource={ref.logs || []}
                                columns={[
                                    { title: "DateTime", dataIndex: 'created_at', key: 'created_at' },
                                    { title: "Username", dataIndex: 'username', key: 'username' },
                                    { title: "Name", dataIndex: 'name', key: 'name' },
                                    { title: "Action", dataIndex: 'action', key: 'action' }
                                ]}
                                pagination={false}
                                size='small'
                                className='main-table separator-table'
                            />
                        </Collapse.Panel>
                    </Collapse>
                </div><div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    // borderTop: `1px solid ${COLORS.border_basic}`,
                    paddingTop: TOP_BOTTOM_PADDING, paddingBottom: TOP_BOTTOM_PADDING,
                    paddingLeft: LEFT_RIGHT_PADDING, paddingRight: LEFT_RIGHT_PADDING
                }}>
                        {typeof onApprove === 'function' &&
                            <a className='heading-4' style={{
                                marginRight: 40,
                                color: COLORS.success_primary
                            }}
                                onClick={() => {
                                    onApprove(id, data, index)
                                }}
                            >APPROVE</a>}
                        {typeof onReject === 'function' &&
                            <Popconfirm title={`Are you sure you want to reject this record?`}
                                onConfirm={() => {
                                    onReject(id, data, index)
                                }}
                            >

                                <a className='heading-4' style={{
                                    // marginRight:40,
                                    color: COLORS.danger_primary
                                }}
                                    onClick={() => {
                                    }}
                                >REJECT</a>
                            </Popconfirm>
                        }
                    </div>
                </React.Fragment> : null}



            </div>

        </div>
    )
}
